import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AnalyticsTracker } from "@/components/AnalyticsTracker";

import Home from "@/pages/Home";
import Speaking from "@/pages/Speaking";
import WorkWithMe from "@/pages/WorkWithMe";
import SparkSessions from "@/pages/SparkSessions";
import ConsistencyCorner from "@/pages/ConsistencyCorner";
import VisionBookWorkshop from "@/pages/VisionBookWorkshop";
import BelievingHappy from "@/pages/BelievingHappy";
import About from "@/pages/About";
import Books from "@/pages/Books";
import BlogList from "@/pages/BlogList";
import BlogArticle from "@/pages/BlogArticle";
import JoyspotRedirect from "@/pages/JoyspotRedirect";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import SiteShell from "@/components/site/SiteShell";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminArticleForm from "@/pages/admin/AdminArticleForm";

function App() {
  return (
    <div className="App bg-[#FAFAF8] text-[#1C1917]">
      <AdminAuthProvider>
        <BrowserRouter>
          <AnalyticsTracker />
          <Routes>
            <Route element={<SiteShell />}>
              <Route path="/" element={<Home />} />
              <Route
                path="/joyspot"
                element={<JoyspotRedirect />}
              />
              <Route
                path="/about"
                element={<About />}
              />
              <Route
                path="/work-with-me"
                element={<WorkWithMe />}
              />
              <Route
                path="/work-with-me/spark-sessions"
                element={<SparkSessions />}
              />
              <Route
                path="/work-with-me/consistency-corner"
                element={<ConsistencyCorner />}
              />
              <Route
                path="/work-with-me/vision-book-workshop"
                element={<VisionBookWorkshop />}
              />
              <Route
                path="/believing-happy"
                element={<BelievingHappy />}
              />
              <Route
                path="/books"
                element={<Books />}
              />
              <Route
                path="/this-curious-life"
                element={<BlogList />}
              />
              <Route
                path="/this-curious-life/:slug"
                element={<BlogArticle />}
              />
              <Route
                path="/speaking"
                element={<Speaking />}
              />
              <Route
                path="/privacy"
                element={<Privacy />}
              />
              <Route
                path="/terms"
                element={<Terms />}
              />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/articles/new"
                element={
                  <ProtectedRoute>
                    <AdminArticleForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/articles/:id/edit"
                element={
                  <ProtectedRoute>
                    <AdminArticleForm />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AdminAuthProvider>
    </div>
  );
}

export default App;
